export const cleanNumericFormatField = (value: string | undefined) => {
  // Remove the £ and , that NumericFormat component adds before sending to the API
  if (!value) return value;
  return value.replace(/£|,/g, '');
};
